import { Id } from 'react-toastify';

import { useMutation } from '@tanstack/react-query';

import { notificationService } from 'services';

export const useReadNotification = () => {
  const { mutateAsync: read } = useMutation({
    mutationFn: (id: Id) => notificationService.readNotification(id),
  });

  return { read };
};
